import SignupPageAddonToken from '@apps/maha/admin/tokens/signup_page_addon'
import SignupPagePlanToken from '@apps/maha/admin/tokens/signup_page_plan'
import MJSONPreview from '@admin/components/mjson_preview'
import ShortLink from '@admin/components/shortlink'
import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Edit from '../edit'
import React from 'react'

const Overview = ({ signup_page }) => {

  const shortlink = {
    shortlink: signup_page.shortlink,
    text: 't(Share this Signup Page)',
    title: signup_page.title
  }
  
  const details = {
    audits: `maha_signup_pages/${signup_page.id}`,
    comments: `maha_signup_pages/${signup_page.id}`,
    before: <ShortLink { ...shortlink } />,
    header: <MJSONPreview entity={ signup_page } table="maha_signup_pages" />,
    sections: [
      {
        title: 't(Signup Page Details)',
        items: [
          { label: 't(Title)', content: signup_page.title },
          { label: 't(Entity)', content: signup_page.entity_type },
          { label: 't(Pro)', content: signup_page.config.pro, format: SignupPagePlanToken },
          { label: 't(Essentials)', content: signup_page.config.essentials, format: SignupPagePlanToken },
          { label: 't(Logo Design)', content: signup_page.config.logo, format: SignupPageAddonToken },
          { label: 't(Brand Design)', content: signup_page.config.brand, format: SignupPageAddonToken },
          { label: 't(Single Page Website)', content: signup_page.config.singlepage, format: SignupPageAddonToken },
          { label: 't(Seven Page Website)', content: signup_page.config.sevenpage, format: SignupPageAddonToken },
          { label: 't(Free Setup)', content: signup_page.config.free_setup, format: 'yes_no' },
          { label: 't(Setup Fee)', content: signup_page.config.setup_fee, format: 'money' },
          { label: 't(Trial Length)', content: signup_page.config.trial_length }
        ]
      }
    ]
  }

  if(signup_page.deleted_at !== null) {
    details.alert = { color: 'red', message: 't(This signup page was deleted)' }
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  signup_page: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview signup_page={ props.signup_page } />,
  tasks: {
    items: [
      {
        label: 't(Edit Signup Page)',
        svg: 'square_pen',
        modal: <Edit signup_page={ props.signup_page } />
      },
      {
        label: 't(Delete Signup Page)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this signup page?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/signup_pages/${props.signup_page.id}`,
          method: 'DELETE',
          onSuccess: (result) => {
            context.flash.set('success', 'Signup page was deleted successfully')
            context.router.goBack()
          },
          onFailure: (result) => context.flash.set('error', 'Unable to delete signup page')
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
